/**
 * 用于我的 页面展示数据
 * @type {Array<mine.MineOrderType>}
 * */
export const ORDER_LIST = [
  {
    name: '待付款',
    imgName: 'order-icon1.png',
    type: '2',
    key: 'waitingPayOrderCount',
  },
  {
    name: '待发货',
    imgName: 'order-icon2.png',
    type: '3',
    key: 'waitingSendOrderCount',
  },
  {
    name: '待收货',
    imgName: 'order-icon3.png',
    type: '4',
    key: 'waitingReceiveOrderCount',
  },
  {
    name: '待评价',
    imgName: 'order-icon4.png',
    type: '5',
    key: 'waitingCommentOrderCount',
  },
  {
    name: '售后',
    imgName: 'order-icon5.png',
    type: '10',
  },
]

/**
 * 用于我的 页面展示数据
 * @type {Array<mine.MineOrderType>}
 * */
export const ORDER_ACTIONS = [
  {
    name: '收藏',
    imgName: 'like-icon.png',
    key: 'collectCount',
    link: 'https://mall.baicizhan.com/m/mylike',
    eventId: 'mine_favor_click',
  },
  {
    name: '优惠券',
    imgName: 'coupon.png',
    key: 'couponCount',
    link: 'https://mall.baicizhan.com/m/coupon/index',
    eventId: 'mine_coupon_click',
  },
  {
    name: '购物车',
    imgName: 'd-cart.png',
    key: 'cartGoodsCount',
    link: 'https://bcz-mall.baicizhan.com/new-mall/cart',
    eventId: 'mine_cart_click',
  },
]

/**
 * 评分 映射
 */
export const EVALUATE_LEVEL_MAP = {
  1: {
    txt: '很差',
  },
  2: {
    txt: '差',
  },
  3: {
    txt: '一般',
  },
  4: {
    txt: '很好',
  },
  5: {
    txt: '非常好',
  },
}

/**
 * 我的订单 tab项
 */
export const ORDER_TYPE_LIST = [
  {
    title: '全部',
    key: '1',
  },
  {
    title: '待付款',
    key: '2',
  },
  {
    title: '待发货',
    key: '3',
  },
  {
    title: '待收货',
    key: '4',
  },
  {
    title: '待评价',
    key: '5',
  },
]

/**
 * 订单状态
 */
export const ORDER_STATUS_MAP = {
  /**
   * 已取消 80
   */
  CANCELED: 80,

  /**
   * 异常取消 85
   */
  CANCELED_EXCEPTION: 85,

  /**
   * 已退款 90
   */
  REFUNDED: 90,
  /**
   * 待付款 100
   */
  WAITING_PAY: 100,

  /**
   * 部分支付 203 尾款不可支付
   */
  PAY_APART: 203,

  /**
   * 部分支付 尾款可支付 前端自己加的
   */
  PAY_APART_1: 20301,

  /**
   * 已支付挂起 205 (待付款状态)
   */
  PAY_PENDING: 205,
  /**
   * 待发货 210
   */
  WAITING_SEND: 210,
  /**
   * 待退款 230（退款中）
   */
  WAITING_REFUND: 230,
  /**
   * 待收货 310
   */
  WAITING_RECIVE: 310,

  /**
   * 已签收 320 （属于待收货状态）
   */
  RECIVED: 320,
  /**
   * 已完成 400
   */
  FINISHED: 400,
}

export const ORDER_ACTIONS_TYPES = {
  REFOUND: 'refound',
  DEL: 'del',
  CANCEL: 'cancel',
  RECEIVE: 'receive',
  EVALUATE: 'evalute',
}
